import _ from 'lodash'
import { dataFix } from '../../common/dataFix'

export const rts = {
  handle_ammendRightItems: 'handle_ammendRightItems',
  handle_goto: 'handle_goto',
  handleAdd_navigationItem: 'handleAdd_navigationItem',
  handleAdd_navigationItems: 'handleAdd_navigationItems',
  handleAdd_navigationPopupItems: 'handleAdd_navigationPopupItems',
  handleAdd_sidebarItems: 'handleAdd_sidebarItems',
  handleAmmend_uiviTab: 'handleAmmend_uiviTab',
  handleAmmend_dataOrigin: 'handleAmmend_dataOrigin',
  handleAmmend_frameworkLeft: 'handleAmmend_frameworkLeft',
  handleAmmend_uivi: 'handleAmmend_uivi',
  handleAmmend_frameworkRightCurrent: 'handleAmmend_frameworkRightCurrent',
  handleAmmend_homePageCaption: 'handleAmmend_homePageCaption',
  handleAmmend_pageContent: 'handleAmmend_pageContent',
  handleAmmend_tempSettings: 'handleAmmend_tempSettings',
  handleChanged_override: 'handleChanged_override',
  handleClear_navigationItems: 'handleClear_navigationItems',
  handleClick_contentItem: 'handleClick_contentItem',
  handleHide_appBottomModal: 'handleHide_appBottomModal',
  handleHide_appSidebar: 'handleHide_appSidebar',
  // handleInit_framework: 'handleInit_framework',
  handleKill_pageNav: 'handleKill_pageNav',
  handlePropMode: 'handlePropMode',
  handleSet_currentLongPress: 'handleSet_currentLongPress',
  handleSet_permissionGroups: 'handleSet_permissionGroups',
  handleShow_appBottomModal: 'handleShow_appBottomModal',
  handleShow_appBottomSidebar: 'handleShow_appBottomSidebar',
  handleShow_appDashboard: 'handleShow_appDashboard',
  handleShow_appSidebar: 'handleShow_appSidebar',
  handleShow_appSidebarContent: 'handleShow_appSidebarContent',
  handleShow_frameworkLeft: 'handleShow_frameworkLeft',
  handleShow_frameworkRight: 'handleShow_frameworkRight',
  handleShow_frameworkRightContent: 'handleShow_frameworkRightContent',
  handleShow_frameworkRightData: 'handleShow_frameworkRightData',
  handleShow_fullPage: 'handleShow_fullPage',
  handleShow_itemEdit: 'handleShow_itemEdit',
  handleShow_pageNav: 'handleShow_pageNav',
  handleShow_settingSoloSidebar: 'handleShow_settingSoloSidebar',
  handleShow_signIn: 'handleShow_signIn',
  handleToggle_leftMenu: 'handleToggle_leftMenu',
  handleToggle_rightMenu: 'handleToggle_rightMenu',
  handleUiItem: 'handleUiItem',
  handleUpdate_propsFromToggled: 'handleUpdate_propsFromToggled',
  handleSet_ref: 'handleSet_ref',
}

export const _appSidebarContentTypes = {
  appSharing: 'appSharing',
  wifi: 'wifi',
  link: 'link',
  linkFull: 'linkFull',
  notificationCheck: 'notificationCheck',
}

export const frameworkLeftTypes = {
  appData: 'appData',
  appProfilesManager: 'appProfilesManager',
  appUsersManager: 'appUsersManager',
  appUsersPresense: 'appUsersPresense',
  bulkImageUpload: 'bulkImageUpload',
  clearCache: 'clearCache',
  clearCacheData: 'clearCacheData',
  clearCacheSettings: 'clearCacheSettings',
  createNewEvent: 'createNewEvent',
  notificationsManager: 'notificationsManager',
  recreateNewEvent: 'recreateNewEvent',
  refreshCache: 'refreshCache',
  refreshGoogleSheets: 'refreshGoogleSheets',
  settings: 'settings',
  updateManifest: 'updateManifest',
}

export const frameworkRightTypes = {
  appUserProfile: 'appUserProfile',
  dataConstraints: 'dataConstraints',
  dataModification: 'dataModification',
  display: 'display',
  filters: 'filters',
  google: 'google',
  pageDataAdd: 'pageDataAdd',
  pageDataEdit: 'pageDataEdit',
  pageLinkData: 'pageLinkData',
  pageMedia: 'pageMedia',
  pageSettings: 'pageSettings',
  pageSettingsFull: 'pageSettingsFull',
  props: 'props',
  settings: 'settings',
  showDataJson: 'showDataJson',
  showLog: 'showLog',
  sorting: 'sorting',
  sportScoresViewer: 'sportScoresViewer',
}

export const frameworkDashboardTypes = {
  golfViewer: 'golfViewer',
  sportsViewer: 'sportsViewer',
  sportScoresViewer: 'sportScoresViewer',
}

export const frameworkReducer = (state, action) => {

  const { appSidebarContentType, appUser } = state

  switch (action.type) {

    case rts.handleSet_ref:
      return { ...state, frameworkRef: action.frameworkRef }

    case rts.handleAmmend_pageContent:
      const _components = { ...state.components }
      _components[action.componentType] = action.component
      return { ...state, components: _components }

    case rts.handle_ammendRightItems:
      return { ...state, ...action.options }

    case rts.handleSet_currentLongPress:
      return { ...state, currentLongPress: action.currentLongPress }

    case rts.handleSet_permissionGroups:
      return { ...state, permissionGroups: action.permissionGroups }

    case rts.handle_goto:
      return { ...state }

    case rts.handleClick_contentItem:
      const { navProps } = action ?? {}
      return { ...state, iconClickProps: navProps }

    case rts.handleToggle_leftMenu:
      return { ...state, showLeftMenuCaptions: !state.showLeftMenuCaptions }

    case rts.handleToggle_rightMenu:
      return { ...state, showRightMenuCaptions: !state.showRightMenuCaptions }

    case rts.handleChanged_override:
      return { ...state, overridesChanged: action.overridesChanged }

    case rts.handleUpdate_propsFromToggled:
      const callback = (rs) => {
        console.log('rs', rs)
      }
      const { frInfo: frInfo_state, settingsDocName: settingsDocName_state } = state
      const { pageSettings, view: view_fri, uivi: uivi_fri } = frInfo_state ?? {}
      const { aps_views } = pageSettings ?? {}
      const aps_view = aps_views && view_fri && aps_views[view_fri] ? aps_views[view_fri] : {}

      const { viewItems } = aps_view ?? {}
      const _viewItem = viewItems[uivi_fri]

      updateOverrides(appUser, aps_views, _viewItem, view_fri, settingsDocName_state, callback)
      return { ...state }

    case rts.handleShow_fullPage:
      const _showFullPage = !state.showFullPage
      return { ...state, fullPageType: _showFullPage ? action.fullPageType : null, showFullPage: _showFullPage }

    case rts.handleShow_itemEdit:
      return { ...state, modifyActionItem: action.modifyActionItem }

    case rts.handleShow_pageNav:
      return { ...state, modifyActionType: action.dmiKey }

    case rts.handleKill_pageNav:
      return { ...state, modifyActionType: null }

    case rts.handleUiItem:
      const { results } = action
      const { uivi, viewKey, _uiItem } = results ?? {}
      const _uiItems = { ...state.uiItems }
      const _pageItems = { ...state.pageItems }
      if (viewKey) {
        if (!_uiItems[uivi]) { _uiItems[uivi] = {} }
        _uiItems[uivi][viewKey] = _uiItem
      } else {
        _pageItems[uivi] = _uiItem
      }
      return { ...state, uiItems: _uiItems, pageItems: _pageItems }

    case rts.handleShow_appDashboard:
      return {
        ...state,
        showAppDashboard: !state.showAppDashboard,
        selectedDataMode: action.selectedDataMode,
        selectedCollectionKey: action.collectionKey,
        fromRight: action.fromRight,
      }

    case rts.handleShow_appSidebar:
      return {
        ...state,
        appSidebarOpen: !state.appSidebarOpen,
        settingsSidebarSoloOpen: false,
        appSidebarContentType: null
      }

    case rts.handleShow_appBottomModal:
      return {
        ...state,
        showAppBottomModal: true,
        appBottomModalContent: action.longPressModal
      }

    case rts.handleHide_appBottomModal:
      return {
        ...state,
        showAppBottomModal: false,
        appBottomModalContent: null
      }

    case rts.handleShow_appBottomSidebar:
      const _show_abs = !state.showAppBottomSidebar
      return {
        ...state,
        showAppBottomSidebar: _show_abs,
        bottomSidebarContent: _show_abs ? action.content : null
      }

    case rts.handleHide_appSidebar:
      return {
        ...state,
        appSidebarHide: !action.hide,
        appSidebarContentType: null
      }

    case rts.handleShow_signIn:
      return {
        ...state,
        appSidebarOpen: false,
        settingsSidebarSoloOpen: false,
        showSignIn: !state.showSignIn,
        appSidebarContentType: null
      }

    case rts.handleShow_settingSoloSidebar:
      return {
        ...state,
        settingsSidebarSoloOpen: !state.settingsSidebarSoloOpen,
        soloPermissionType: action.soloPermissionType,
        appSidebarContentType: null
      }

    case rts.handlePropMode:
      return {
        ...state,
        propMode: !state.propMode,
      }

    case rts.handleShow_appSidebarContent:

      if (appSidebarContentType === action.appSidebarContentType) {
        return { ...state, appSidebarContentType: action.null }
      } else {
        return { ...state, appSidebarContentType: action.appSidebarContentType }
      }

    case rts.handleShow_frameworkLeft:
      const _pageLeftType = state.frameworkLeftType === action.frameworkLeftType ? null : action.frameworkLeftType
      return {
        ...state,
        frameworkLeftType: _pageLeftType
      }

    case rts.handleShow_frameworkRight:
      const _pageRightType = state.frameworkRightType === action.frameworkRightType ? null : action.frameworkRightType
      const _page = state.frameworkRightType === action.frameworkRightType ? null : action.page

      return {
        ...state,
        frameworkRightType: _pageRightType,
        dataModifyType: action.dataModifyType,
        pageSettingsPage: _page,
        tempSettings: !_pageRightType ? null : state.tempSettings
      }


    case rts.handleAmmend_dataOrigin:
      return {
        ...state,
        dataOrigin: action.dataOrigin
      }

    case rts.handleAmmend_frameworkLeft:
      const _flInfos = { ...state.flInfos }
      const { flInfo } = action
      return {
        ...state,
      }

    case rts.handleAmmend_uiviTab:
      return {
        ...state,
        frInfo: state?.frInfos?.[action.uivi],
        fw_info: {
          view: action.view,
          uivi: action.uivi,
          viewKey: action.viewKey
        },
        currentSwiperTab: action.uivi,
      }

    case rts.handleAmmend_uivi:
      const _frInfos = state.frInfos ? { ...state.frInfos } : {}
      const { frInfo } = action
      const { viewItem, uivi: uivi_fr, settingsDocName, navigationOptions } = frInfo ?? {}
      if (viewItem) {
        const _frKey = uivi_fr ? uivi_fr : view
        _frInfos[_frKey] = frInfo
        const _frInfo = _frInfos[_frKey]
        const { view, uivi, viewItemStatus, currentPageData } = _frInfo ?? {}
        const { isViewItemSubList } = viewItemStatus ?? {}
        const { _itemKey } = currentPageData ?? {}
        _frInfo.captions = {
          add: getAddCaption(view, uivi, _itemKey, isViewItemSubList),
          edit: 'Edit ' + _.startCase(uivi) + ' (' + _itemKey + ')',
        }
        const frprs = {
          // propsToggled: null,
          frInfos: _frInfos,
          settingsDocName,
          navigationOptions,
          frInfo,
          currentSwiperView: uivi,
          currentSwiperTab: uivi,
          fw_info: {
            view: frInfo?.view,
            uivi: frInfo?.uivi,
            viewKey: frInfo?.viewKey,
          },
        }
        const cmb = { ...state, ...frprs }
        return { ...cmb }
      } else {
        // return { ...state, propsToggled: null }
        return state
      }

    case rts.handleAmmend_frameworkRightCurrent:
      const _frInfoz = state.frInfos
      const _frInfoS = _frInfoz && _frInfoz[action.viewItemKey] ? _frInfoz[action.viewItemKey] : null
      if (_frInfoS) {
        const { navigationOptions: navigationOptions_s } = _frInfoS
        const _frAllows = getFrAllows(_frInfoS)
        return { ...state, frAllows: _frAllows, frInfo: _frInfoS, swipeItemKey: action.viewItemKey, navigationOptions: navigationOptions_s }
      } else {

        return { ...state, swipeItemKey: action.viewItemKey }
      }

    case rts.handleShow_frameworkRightContent:
      return {
        ...state,
        frContent: action.frContent,
      }

    case rts.handleShow_frameworkRightData:
      return {
        ...state,
        frInfo: action.frInfo,
      }

    case rts.handleAdd_navigationItem:
      const _navKey = action.navItemKey ? action.navKey + '_' + action.navItemKey : action.navKey
      const _additionalNavigationItems = state.additionalNavigationItems ? state.additionalNavigationItems : {}
      _additionalNavigationItems[_navKey] = action.navigationItem
      return { ...state, additionalNavigationItems: _additionalNavigationItems }

    case rts.handleAdd_navigationItems:
      return { ...state, additionalNavigationItems: action.navItems }

    case rts.handleAdd_navigationPopupItems:
      return { ...state, additionalNavigationPopupItems: action.popupItems }

    case rts.handleClear_navigationItems:
      return { ...state, additionalNavigationItems: null }

    case rts.handleAdd_sidebarItems:
      return { ...state, additionalMenuItems: action.sidebarItems }

    case rts.handleAmmend_tempSettings:
      return { ...state, tempSettings: action.tempSettings }

    case rts.handleAmmend_homePageCaption:
      return { ...state, homePageCaption: action.homePageCaption }

    default:
      return { ...state }
  }
}

export const frameworkHandlers = (dispatch) => {
  return {
    handleSet_ref: (frameworkRef) => { dispatch({ type: rts.handleSet_ref, frameworkRef }) },
    handle_ammendRightItems: (options) => { dispatch({ type: rts.handle_ammendRightItems, options }) },
    handle_goto: (item) => { dispatch({ type: rts.handle_goto, item }) },
    handle_goto: (item) => { dispatch({ type: rts.handle_goto, item }) },
    handleAdd_navigationItem: (navKey, navigationItem, navItemKey) => { dispatch({ type: rts.handleAdd_navigationItem, navKey, navigationItem, navItemKey }) },
    handleAdd_navigationItems: (navItems) => { dispatch({ type: rts.handleAdd_navigationItems, navItems }) },
    handleAdd_navigationPopupItems: (popupItems) => { dispatch({ type: rts.handleAdd_navigationPopupItems, popupItems }) },
    handleAdd_sidebarItems: (sidebarItems) => { dispatch({ type: rts.handleAdd_sidebarItems, sidebarItems }) },
    handleAmmend_uiviTab: (view, uivi, viewKey) => { dispatch({ type: rts.handleAmmend_uiviTab, view, uivi, viewKey }) },
    handleAmmend_dataOrigin: (dataOrigin) => { dispatch({ type: rts.handleAmmend_dataOrigin, dataOrigin }) },
    handleAmmend_frameworkLeft: (flInfo, origin) => { dispatch({ type: rts.handleAmmend_frameworkLeft, flInfo, origin }) },
    handleAmmend_uivi: (frInfo, origin) => { dispatch({ type: rts.handleAmmend_uivi, frInfo, origin }) },
    handleAmmend_frameworkRightCurrent: (viewItemKey, origin) => { dispatch({ type: rts.handleAmmend_frameworkRightCurrent, viewItemKey, origin }) },
    handleAmmend_homePageCaption: (homePageCaption) => { dispatch({ type: rts.handleAmmend_homePageCaption, homePageCaption }) },
    handleAmmend_pageContent: (componentType, component) => { dispatch({ type: rts.handleAmmend_pageContent, dispatch, componentType, component }) },
    handleAmmend_tempSettings: (tempSettings) => { dispatch({ type: rts.handleAmmend_tempSettings, tempSettings }) },
    handleChanged_override: (overridesChanged) => { dispatch({ type: rts.handleChanged_override, overridesChanged }) },
    handleClear_navigationItems: () => { dispatch({ type: rts.handleClear_navigationItems }) },
    handleClick_contentItem: (navProps) => { dispatch({ type: rts.handleClick_contentItem, navProps }) },
    handleHide_appBottomModal: () => { dispatch({ type: rts.handleHide_appBottomModal }) },
    handleHide_appSidebar: (hide) => { dispatch({ type: rts.handleHide_appSidebar, hide }) },
    // handleInit_framework: (parentContext, pageIcons) => { dispatch({ type: rts.handleInit_framework, parentContext, pageIcons }) },
    handleKill_pageNav: () => { dispatch({ type: rts.handleKill_pageNav }) },
    handlePropMode: () => { dispatch({ type: rts.handlePropMode }) },
    handleSet_currentLongPress: (currentLongPress) => { dispatch({ type: rts.handleSet_currentLongPress, currentLongPress }) },
    handleSet_permissionGroups: (permissionGroups) => { dispatch({ type: rts.handleSet_permissionGroups, permissionGroups }) },
    handleShow_appBottomModal: (longPressModal) => { dispatch({ type: rts.handleShow_appBottomModal, longPressModal }) },
    handleShow_appBottomSidebar: (content) => { dispatch({ type: rts.handleShow_appBottomSidebar, content }) },
    handleShow_appDashboard: (selectedDataMode, collectionKey, fromRight) => { dispatch({ type: rts.handleShow_appDashboard, dispatch, selectedDataMode, collectionKey, fromRight }) },
    handleShow_appSidebar: () => { dispatch({ type: rts.handleShow_appSidebar }) },
    handleShow_appSidebarContent: (appSidebarContentType) => { dispatch({ type: rts.handleShow_appSidebarContent, appSidebarContentType }) },
    handleShow_frameworkLeft: (page, frameworkLeftType) => { dispatch({ type: rts.handleShow_frameworkLeft, dispatch, frameworkLeftType, page }) },
    handleShow_frameworkRight: (page, frameworkRightType, dataModifyType, frv) => { dispatch({ type: rts.handleShow_frameworkRight, dispatch, frameworkRightType, dataModifyType, page, frv }) },
    handleShow_frameworkRightContent: (frContent) => { dispatch({ type: rts.handleShow_frameworkRightContent, dispatch, frContent }) },
    handleShow_frameworkRightData: (frInfo) => { dispatch({ type: rts.handleShow_frameworkRightData, dispatch, frInfo }) },
    handleShow_fullPage: (fullPageType) => { dispatch({ type: rts.handleShow_fullPage, fullPageType }) },
    handleShow_itemEdit: (modifyActionItem) => { dispatch({ type: rts.handleShow_itemEdit, modifyActionItem }) },
    handleShow_pageNav: (item, dmiKey, subKey) => { dispatch({ type: rts.handleShow_pageNav, item, dmiKey, subKey }) },
    handleShow_settingSoloSidebar: (soloPermissionType) => { dispatch({ type: rts.handleShow_settingSoloSidebar, soloPermissionType }) },
    handleShow_signIn: () => { dispatch({ type: rts.handleShow_signIn }) },
    handleToggle_leftMenu: () => { dispatch({ type: rts.handleToggle_leftMenu }) },
    handleToggle_rightMenu: () => { dispatch({ type: rts.handleToggle_rightMenu }) },
    handleUiItem: (results) => { dispatch({ type: rts.handleUiItem, results }) },
    handleUpdate_propsFromToggled: () => { dispatch({ type: rts.handleUpdate_propsFromToggled }) },
  }
}

export const frameworkReducerInitialState = (initState) => {
  const { smartphone, addSettings, mediaDeviceType, isMobileDevice, view, appViewMode, pathViews, appUser } = initState
  return {
    additionalNavigationItems: {},
    addSettings,
    appUser,
    frAllows: {},
    frInfo: {},
    frInfos: {},
    flInfos: {},
    appDimensions: {
      width: smartphone.viewportWidth,
      height: smartphone.viewportHeight,
      deivce: smartphone,
    },
    appSidebarOpen: false,
    appViewMode,
    isMobileDevice,
    mediaDeviceType,
    pageItems: {},
    pathViews,
    settingsSidebarSoloOpen: false,
    standalone: navigator.standalone,
    uiItems: {},
    view,
    currentRefs: {},
    components: {},
    // showLeftMenuCaptions: true,
    // showRightMenuCaptions: true,
  }
};

const getFrAllows = (frInfo, _isViewMatch) => {
  const { view, viewItem, viewKey } = frInfo
  const { dataConstraints, key: key_viewItem } = viewItem ?? {}
  const _viewItemIsView = view === key_viewItem && viewKey ? true : false
  const { useDataConstraints, useDataMatchConstraints, usePageConstraint, useAppUserPageConstraint, useAppUserDataConstraint } = dataConstraints ?? {}
  const _hasConstraints = (useDataConstraints || useDataMatchConstraints || usePageConstraint || useAppUserPageConstraint || useAppUserDataConstraint)
  const frAllows = {
    add: viewKey && _viewItemIsView ? false : true,
    edit: viewKey && _viewItemIsView ? true : false,
    linking: _viewItemIsView ? false : true,
    constraints: _hasConstraints ? true : false,
    isTab: !_viewItemIsView && viewKey ? true : false,
    sorting: viewKey ? false : true,
    google: viewKey ? false : true,
    allowFor: key_viewItem
  }
  return frAllows
}

const updateOverrides = (appUser, aps_views, viewItem, view_fri, settingsDocName_state, callback) => {

  const { props, propSections } = viewItem ?? {}

  _.forEach(props, (prop) => {
    const { _overrides } = prop ?? {}
    _.forEach(_overrides, (_override, _overrideKey) => {
      if (!_.isNull(_override)) {
        prop[_overrideKey] = _override
      } else {
        if (prop[_overrideKey]) {
          delete prop[_overrideKey]
        }
      }
    })
  })

  _.forEach(propSections, (propSection) => {
    const { _overrides } = propSection ?? {}
    _.forEach(_overrides, (_override, _overrideKey) => {
      if (!_.isNull(_override)) {
        propSection[_overrideKey] = _override
      } else {
        if (propSection[_overrideKey]) {
          delete propSection[_overrideKey]
        }
      }
    })
  })

  const _viewItem = dataFix.cleanObject(viewItem)
  const _dataToUpdate = aps_views[view_fri]
  _dataToUpdate.viewItems[view_fri] = _viewItem
  appSettings_fns.updateFromSidebar(settingsDocName_state, view_fri, _dataToUpdate, appUser, callback)
}

const getAddCaption = (view, uivi, _itemKey, isViewItemSubList) => {
  if (isViewItemSubList || view === 'landing' || (uivi === view)) {
    return 'Add ' + _.startCase(uivi)
  } else {
    return 'Add ' + _.startCase(uivi) + ' to ' + _.startCase(view) + ' (' + _itemKey + ')'
  }
}